const items = [
  "Clear Communication",
  "Informed Care",
  "Patient Well-being",
  "SGRR Medical College & Hospital",
  "Pharmacology",
  "Dehradun · Uttarakhand",
];

export function TrustMarquee() {
  const row = [...items, ...items];
  return (
    <section className="py-8 border-y border-[#E2E8F0] bg-[#F4F7FA] overflow-hidden" data-testid="trust-marquee">
      <div className="flex gap-24 whitespace-nowrap animate-none" style={{ animation: "marquee 42s linear infinite" }}>
        {row.map((t, i) => (
          <span key={i} className="font-display text-3xl md:text-4xl text-[#0A192F]/70 italic">
            {t}
          </span>
        ))}
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0);} to { transform: translateX(-50%);} }`}</style>
    </section>
  );
}
